import Ladda from 'ladda';
import UAParser from 'ua-parser-js';
import webcall from '@/scripts/webcall';
import loginController from '@/scripts/libs/login/controller';

const SUPPORT_MODAL_ID = '#modal-support';
const MESSAGE_SYSINFO_HOOK = '::SYS_INFO::';
let tempSystemInfoCache = {};

const availableFields = [
  // Order according to relative order in HTML
  'name',
  'email',
  'subject',
  'message',
];
const _getInputFields = ($modal) => availableFields.reduce((acc, key) => {
  acc[key] = $modal.find('#' + key);
  return acc;
}, {});

const _handleShowModal = function _handleShowModal(prefill = {}, systemInfo = {}, bProgramiticallyTrigger = false) {
  // Prepare DOM
  const $modal = $(SUPPORT_MODAL_ID);
  const $modalFields = _getInputFields($modal);

  // Handle programatically triggered modal
  if (bProgramiticallyTrigger) $modal.modal('show');

  // Initiate support prefill
  const prefillPromise = loginController.getUser()
    .then((user) => {
      if (!user) return;

      Object.entries({
        name: user.profile.firstName + ' ' + user.profile.lastName,
        email: user.profile.email.primaryEmail,
        ...prefill,
      })
        .forEach(([key, value]) => {
          $modalFields[key].val(value);
        });
    });

  // Store system info
  // TODO: =( This sucks. Could this be a js class or vue component?
  tempSystemInfoCache = systemInfo;

  // Handle post modal shown event
  $modal.on('shown.bs.modal', (event) => {
    prefillPromise
      .then(() => {
        // Attempt to focus on next empty field
        availableFields.some((fieldName) => {
          const $field = $modalFields[fieldName];

          const isBlank = !$field.val().trim();

          if (isBlank) $field.focus();
          return isBlank;
        });
      });
  });
};

const _sendFeedback = function _sendFeedback(email, message) {
  // Prepare DOM
  const $modal = $(SUPPORT_MODAL_ID);
  const $modalFields = _getInputFields($modal);

  // Populate additional information
  const ua = window.navigator.userAgent;

  const parser = new UAParser();
  const result = parser.getResult();
  const browser = result.browser.name + ' ' + result.browser.version;
  const platform = result.os.name + ' ' + result.os.version;

  // Retrieve system info to append
  const { destination, ...rest } = tempSystemInfoCache;
  const systemData = '\n\n' + MESSAGE_SYSINFO_HOOK + JSON.stringify({
    ...rest,
  });
  // Post support
  return webcall.postSupport({
    params: {
      // Fields input
      name: $modalFields.name.val(),
      email,
      subject: $modalFields.subject.val(),
      message: message + systemData,

      // Additional info
      current_url: document.URL,
      user_agent: ua,
      browser,
      platform,
      destination: destination || null,
    },
  });
};

const _bindUIActions = function _bindUIActions() {
  const $modal = $(SUPPORT_MODAL_ID);

  $modal.on('show.bs.modal', (event) => {
    _handleShowModal();
  });

  $modal.find('.js-send-feedback').on('click', (event) => {
    // Prepare DOM and handle default events
    const $modalFields = _getInputFields($modal);
    event.preventDefault();
    event.stopPropagation();

    // Reset UI Feedback
    const l = Ladda.create(document.querySelector('.js-send-feedback'));
    l.start();

    $modal.find('.form-group').removeClass('has-error');
    $modal.find('.form-control-feedback').remove();
    $modal.find('.help-block').remove();

    // Gather and validate fields
    const inputEmail = $modalFields.email.val().trim();
    const message = $modalFields.message.val().trim();

    if (!_isEmailValid(inputEmail)) {
      l.stop();
      $modalFields.email
        .focus()
        .parent()
        .addClass('has-danger');
      return;
    }

    if (!message) {
      l.stop();
      $modalFields.message
        .focus()
        .parent()
        .addClass('has-danger')
        .append(`<span class="help-block">${I18n.t('javascript._modal_support.no_message')}</span>`);
      return;
    }

    // Send Feedback
    _sendFeedback(inputEmail, message)
      .then((data) => {
        const l = Ladda.create(document.querySelector('.js-send-feedback'));
        l.stop();
        $modal.modal('hide');
        $modalFields.name.val('');
        $modalFields.subject.val('');
        $modalFields.message.val('');
      });
  });
};

const _isEmailValid = function _isEmailValid(email) {
  const filter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if (!filter.test(email)) {
    return false;
  }
  return true;
};

const VSFeedback = {
  init() {
    _bindUIActions();
  },
  /**
   * Provide an API to programatically trigger the showing of modal
   * @param {Object} prefill
   * @param {Object} systemInfo
   */
  trigger(prefill, systemInfo) {
    _handleShowModal(prefill, systemInfo, true);
  },
};

export default VSFeedback;
